
export class AppConstant {
    public static DATE_FORMAT = 'dd-mm-yy';
    public static TITLE = 'Gems Institution';
    public static ORG_NAME = 'Gems';
    public static DEFAULT_LOGIN: 'OTP' | 'PASSWORD' | 'BOTH' = 'OTP';
    static LOGO_SRC = 'assets/images/logo-small.png';
    static DEFAULT_PROFILE_URL = 'assets/images/avatar.png';
    static DEFAULT_GROUP_IMAGE_URL = 'assets/images/grp-avatar.png';
    static MAX_IMAGE_UPLOAD_SIZE = 1000000; //1mb
    static MAX_FILE_UPLOAD_SIZE = 2000000; // 2mb
    static MAX_VIDEO_UPLOAD_SIZE = 5000000; //5mb
    static DEFAULT_PROFILE_IMAGE = 'assets/images/blank.webp';
    static DEFAULT_GROUP_IMAGE = 'assets/images/blank-profile-picture.jpg';
    static DEFAULT_OLD_IMAGE_APPEND = '[~@!OLDIMAGE!@~]';
    static DEFAULT_DATE_RANGE = '1940:' + new Date().getFullYear().toString();
    static DEFAULT_FUTURE_DATE_RANGE = '1960:' + (new Date().getFullYear() + 5).toString();
    public static GENDER = [
        { id: 1, genderName: 'Male' },
        { id: 2, genderName: 'Female' },
    ];
    public static TABLE_PAGE_ROWS = 10;
}
export const VALIDATOR_PATTERNS = {
    EMAIL: /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/,
    MOBILE: /^[6-9]{1}[0-9]{9}$/,
    NUMBER: /^[0-9]+$/,
    POSITIVE_INTEGER: /\d+/,
    WHOLE_NUMBER: /^[1-9]\d*$/,
    NUMBER_FLOAT: /^[+-]?([0-9]*[.])?[0-9]+$/,
    TEXT: /^([a-zA-Z0-9+_+-]+\s)*[a-zA-Z0-9+_+-]+$/,
    TEXT_NOT_SPACE_IN_BETWEEN: /^(?=.{1,50}$)[a-zA-Z]+(?:['_.\\s][a-zA-Z]+)*$/,
    TEXT_ONLY: /^([a-zA-Z]+\s)*[a-zA-Z]+$/,
    IFC_CODE: /^[A-Z]{4}0[A-Z0-9]{6}$/,
    PINCODE: /^[1-9][0-9]{5}$/,
    AADHAR_VALIDATOR: /^[2-9]{1}[0-9]{3}[0-9]{8}$/,
    MUST_BE: function (s: number) { return new RegExp(`^.{${s}}$`) }
}

export const MODULE_NAME = {
    STAFF: 1,
    MASTER: 2,
    USER: 3,
    STUDENT: 4,
    FEES: 5,
    REPORT: 6,
    SCHOOL: 7,
    ATTENDANCE: 8
}

export const PERMISSION = {
    ADD: 1,
    UPDATE: 2,
    DELETE: 3,
    READ: 4,
    VERIFY: 5,
    MANAGE_FEES: 6,
    MANAGE_OFFICE: 7,
    VIEW_ALL: 8,
    RELIVE: 9,
    MANAGE_ROLE: 10,
    MANAGE_EMAIL_TEMPLATES: 11
}
export const RESPONSE_CODE = {
    SUCCESS: 200,
    VALIDATION_ERROR: 400,
    ERROR: 500,
    METHOD_ERROR: 405,
}
export const ALIVE_STATUS = [
    { id: 1, alive_statusName: 'Active', color: 'success' },
    { id: 2, alive_statusName: 'Died', color: 'danger' },
]

export const STATUS_TBL = {
    1: "Active",
    0: "In Active"
}

export const MONTH = [
    { name: 'Apr', id: 4 },
    { name: 'May', id: 5 },
    { name: 'Jun', id: 6 },
    { name: 'Jul', id: 7 },
    { name: 'Aug', id: 8 },
    { name: 'Sep', id: 9 },
    { name: 'Oct', id: 10 },
    { name: 'Nov', id: 11 },
    { name: 'Dec', id: 12 },
    { name: 'Jan', id: 1 },
    { name: 'Feb', id: 2 },
    { name: 'Mar', id: 3 },
];